module.exports = __webpack_public_path__ + "static/media/WXRWYR5.cc8a7bba.png";